import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { CircleCrossIcon, CircleMinusIcon, CircleOnlyIcon } from '@wf-sl/common-icons'

const propTypes = {
    className: PropTypes.string,
    status: PropTypes.string,
    width: PropTypes.number
}

const defaultProps = {
    width: 16
}

const STATUSES = {
    AVAILABLE: 'AVAILABLE',
    BUSY: 'BUSY',
    NOT_AVAILABLE: 'NOT_AVAILABLE'
}

/**
 * This function to return a status icon to the specific given status.
 * Available statuses are, 'AVAILABLE', 'BUSY' and 'NOT_AVAILABLE'.
 *
 * @example
 * <IconStatusIcon status="AVAILABLE" width={16} />
 *
 * @param {string} [props.className] - Additional className for status icon.
 * @param {string} [props.status] - The given status.
 * @param {string} [props.width=16] - The width for the status icon.
 * @returns {ReactElement|null}
 */
export default function IconStatusIcon(props) {
    const { className, status, width } = props

    switch (status) {
        case STATUSES.AVAILABLE:
            return <CircleOnlyIcon className={cx('t3sel-icon-status-available', className)} {...{ width }} />
        case STATUSES.BUSY:
            return <CircleMinusIcon className={cx('t3sel-icon-status-busy', className)} {...{ width }} />
        case STATUSES.NOT_AVAILABLE:
            return <CircleCrossIcon className={cx('t3sel-icon-status-not-available', className)} {...{ width }} />
        default:
            return null
    }
}

IconStatusIcon.defaultProps = defaultProps
IconStatusIcon.propTypes = propTypes
